import { Component } from '@angular/core';

@Component({
    selector: 'tnb-settings-page',
    templateUrl: './settings-page.component.html',
    styleUrls: [
        './settings-page.component.scss',
    ],
    standalone: false,
})
export class SettingsPageComponent {

    constructor() {
    }

}
